//action_types
export const SET_CUSTOM_LIST = "SET_CUSTOM_LIST";
export const SET_CURRENT_WORD_LIST_ID = "SET_CURRENT_WORD_LIST_ID";
export const SET_CURRENT_GRID_SIZE = "SET_CURRENT_GRID_SIZE";
export const SET_DISPLAYED_LIST = "SET_DISPLAYED_LIST";
export const SET_HIDDEN_WORD = "SET_HIDDEN_WORD";
export const TOGGLE_SHUFFLE = "TOGGLE_SHUFFLE";


//action creators
export function setCustomList(listAsString) {
    return {
        type: SET_CUSTOM_LIST,
        listAsString,
    }
}

export function setDisplayedList(list) {
    return {
        type: SET_DISPLAYED_LIST,
        list,
    }
}

export function setCurrentWordListId(listId) {
    return {
        type: SET_CURRENT_WORD_LIST_ID,
        listId,
    }
}

export function setCurrentGridSize(gridSize) {
    return {
        type: SET_CURRENT_GRID_SIZE,
        gridSize,
    }
}

export function setHiddenWord(word) {
    return {
        type: SET_HIDDEN_WORD,
        word,
    }
}


export function toggleShuffle(shuffled) {
    return {
        type: TOGGLE_SHUFFLE,
        shuffled,
    }
}
